export default "__VITE_ASSET__DmV0S6qc__"